import React from 'react'
import PropTypes from 'prop-types'
import FlexRow from '../../../../components/molecules/FlexRow'

function Disclaimer ({ message }) {
  return (
    <FlexRow className='justify-center font-sans font-size-xs p-xs'>
      <span style={{ color: 'var(--dai-color-text-low)' }}>{message}</span>
    </FlexRow>
  )
}

Disclaimer.propTypes = {
  message: PropTypes.string
}

Disclaimer.defaultProps = {
  message: 'AI-powered content. Human review recommended.'
}

export default Disclaimer
